import { render, staticRenderFns } from "./SplitterInformation.vue?vue&type=template&id=334f1ca1"
import script from "./SplitterInformation.vue?vue&type=script&lang=js"
export * from "./SplitterInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports